import axios from 'axios'
import getAppConfig from '../config/getAppConfig'
import { isExternalDomain } from '../globalUtills/common'
import { HEADER_PARAM, MEMORY_KEY } from '../globalConfig/appConstant'

/**
 * Fetches menu list details for the provided user type (External E / Internal I).
 *
 * @async
 * @function fetchProductDetailsAndMenus
 * @returns {Promise<Object>} The response data from the API, or an error message object if the request fails.
 */
export const fetchProductDetailsAndMenus = async () => {
  const config = await getAppConfig()
  try {
    const response = await axios.get(
      `${isExternalDomain() ? config?.itemHubAppService?.baseExternal : config?.itemHubAppService?.base}${config?.itemHubAppService?.menu}`,
      {
        method: 'GET',
        headers: {
          [HEADER_PARAM.AUTHORIZATION]: localStorage.getItem(
            MEMORY_KEY.ACCESS_TOKEN,
          ),
          [HEADER_PARAM.X_API_KEY]: config?.itemHubAppService?.apiKey,
          [HEADER_PARAM.ID2_TOKEN]: localStorage.getItem(MEMORY_KEY.ID_TOKEN),
        },
      },
    )
    return response?.data
  } catch (error) {
    console.error('Error fetching product details and menus:', error)
  }
}

/**
 * Fetches product release notes for a given user type (External E / Internal I).
 *
 * @async
 * @function fetchProductReleaseNotes
 * @param {string} userType - The type of user requesting the release notes.
 * @returns {Promise<Object>} The response data containing release notes, or an error message object if the request fails.
 */
export const fetchProductReleaseNotes = async () => {
  const config = await getAppConfig()
  try {
    const response = await axios.get(
      `${isExternalDomain() ? config?.itemHubAppService?.baseExternal : config?.itemHubAppService?.base}${config?.itemHubAppService.releaseNotes}`,
      {
        headers: {
          [HEADER_PARAM.AUTHORIZATION]: localStorage.getItem(
            MEMORY_KEY.ACCESS_TOKEN,
          ),
          [HEADER_PARAM.X_API_KEY]: config?.itemHubAppService?.apiKey,
          [HEADER_PARAM.ID2_TOKEN]: localStorage.getItem(MEMORY_KEY.ID_TOKEN),
        },
      },
    )
    return response?.data
  } catch (error) {
    console.error('Error fetching product release notes:', error)
  }
}
